/**
 *  用户相关 API 地址
 *  @swagger http://idaas-tst.earth.xpaas.lenovo.com/doc.html#/home
 */
import { IAjaxConfig } from '../helpers';
export class EnumApiAccountsvr {
  /**
   * @dec 获取图片验证码
   * @method post
   */
  readonly accountsvr_imgCode: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/imgCode',
    method: 'get',
    //  loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 获取lenovoid图片验证码
   * @method post
   */
  readonly accountsvr_imgCode_lid: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/lenovo-id/imgCode',
    method: 'get',
    //  loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 发送短信验证码
   * @method post
   */
  readonly accountsvr_SendCode: IAjaxConfig = {
    // 测试用
    //  url: '/api/gateway/idaas/v1/notification/verification-code/get',
    url: '/api/gateway/idaas/public/v1/notification/verification-code/send',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 注册返回code
   * @method post
   */
  readonly accountsvr_user_add: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/users/add',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 注册code登录
   * @method post
   */
  readonly accountsvr_user_add_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/register/code/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 手机号登录
   * @method post
   */
  readonly accountsvr_sms_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/sms/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 账号密码登录
   * @method post
   */
  readonly accountsvr_account_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/pwd/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 登录微信
   */
  readonly accountsvr_wechat_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/wechat/login',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 保存微信扩展信息
   */
  readonly accountsvr_wechat_extend_save: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/wechat/extend/save',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 获取url授权
   */
  readonly accountsvr_get_url_code: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/security-url/code/sign',
    method: 'get',
    loading: true,
  };

  /**
   * @dec 获取token
   */
  readonly accountsvr_get_token: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/authentication/token/get',
    method: 'get',
    loading: true,
  };

  /**----- onelenovo ----**/

  /**
   * @dec 获取用户信息
   * @method get
   * @params
   */
  readonly accountsvr_get_userinfo: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/users/user/info/get',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @dec 保存用户信息
   * @method put
   * @params
   */
  readonly accountsvr_update_userinfo: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/idaas/user/info/update',
    method: 'put',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 登录后是否需要选择身份
   * @method get
   * @params
   */
  readonly accountsvr_identity_ischoose: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/identity/choose/judge',
    method: 'get',
  };

  /**
   * @dec 切换登录身份
   */
  readonly accountsvr_identity_switch: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/identity/switch',
    method: 'post',
  };

  /**
   * @dec 身份转变，刷新token
   */
  readonly accountsvr_refresh_indentity: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/identity/change/check',
    method: 'post',
  };

  /**
   * @dec 获取isg是否绑定微信
   */
  readonly accountsvr_isg_isbind_wechat: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/wechat/isg/user/get',
    method: 'get',
  };

  /**
   * @dec 退出登录
   */
  readonly accountsvr_loginout: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/token/invalid',
    method: 'put',
  };

  /**
   * @dec scdc单点登录
   */
  readonly accountsvr_dcsc_login: IAjaxConfig = {
    url: '/api/gateway/idaas-protect/dcsc/token/get',
    method: 'get',
  };

  /**
   * @dec 获取dcsc菜单权限
   */
  readonly accountsvr_dcsc_get_authority: IAjaxConfig = {
    url: '/api/gateway/idaas-protect/dcsc/authority/get',
    method: 'get',
  };

  /**
   * @dec 获取dcsc菜单url
   */
  readonly accountsvr_dcsc_get_redirectUrl: IAjaxConfig = {
    url: '/api/gateway/idaas-protect/dcsc/redirectUrl',
    method: 'get',
  };
}
